@if (applicationStateService.userData && applicationStateService.userData.loggedIn && !applicationStateService.isOfflineModeEnabled) {
    <div
            class="dropdown user-menu-dropdown">
        <button [position]="'center 15px'"
                [size]="'55%'" [style.height.px]="'70'" [url]="'sidebar/sidebar-icon-profile.png' | asset" aria-expanded="true" aria-haspopup="true"
                backgroundImage
                class="sidebar-nav-button dropdown-toggle"
                data-bs-toggle="dropdown"
                id="user-menu"
                type="button"><span>{{ applicationStateService.userData.firstName || 'Account' }}</span>
        </button>
        <ul aria-labelledby="user-menu" class="dropdown-menu dropdown-menu-end">
            @if (applicationStateService.userData.accessTo.bookEdit && applicationStateService.bookConfig.editable) {
                <li>
                    <a [attr.href]="'bookEdit' | route: {id: applicationStateService.bookId}" class="dropdown-item"
                       target="_blank">
                        <i aria-hidden="true" class="fa fa-pencil fa-fw"></i> Buch bearbeiten
                    </a>
                </li>
            }
            @if (applicationStateService.userData.accessTo.bookEdit) {
                <li>
                    <a [attr.href]="'indexDashboard' | route" class="dropdown-item">
                        <i aria-hidden="true" class="fa fa-wrench fa-fw"></i> Verwaltung
                    </a>
                </li>
            }
            @if (applicationStateService.userData.accessTo.schoolClass) {
                <li>
                    <a [attr.href]="'manageStudents' | route" class="dropdown-item">
                        <i class="bi bi-easel"></i> Klassen
                    </a>
                </li>
            }
            @if (!applicationStateService.userData.digi4SchoolUser || applicationStateService.userData.merged) {
                <li>
                    <a [attr.href]="'getProfile' | route" class="dropdown-item">
                        <i aria-hidden="true" class="fa fa-user-circle fa-fw"></i> Profil
                    </a>
                </li>
            }
            @if (applicationStateService.userData.digi4SchoolUser && !applicationStateService.userData.merged) {
                <li>
                    <a [attr.href]="'showMergeAccounts' | route" class="dropdown-item">
                        <i aria-hidden="true" class="fa fa-user-circle fa-fw"></i> Nutzer zusammenführen
                    </a>
                </li>
            }
            @if (applicationStateService.bookConfig.bookPermissions.whiteboard.create &&
            applicationStateService.userData.isWhiteboardAuthor &&
            applicationStateService.bookConfig.whiteboard) {
                <li>
                    <button (click)="openWhiteboardsInSidebar()" class="dropdown-item">
                        <i aria-hidden="true" class="fa fa-chalkboard fa-fw"></i> Meine Tafelbilder
                    </button>
                </li>
            }
            @if (applicationStateService.userData.isAdminSession) {
                <li>
                    <a [attr.href]="'userGetRestoreSession' | route" class="dropdown-item">
                        <i aria-hidden="true" class="fas fa-sign-in fa-fw"></i> Zurück zu Admin
                    </a>
                </li>
            }
            <li>
                <a [attr.href]="'logoutUser' | route" class="dropdown-item">
                    <i aria-hidden="true" class="fa fa-sign-out fa-fw"></i> Abmelden
                </a>
            </li>
        </ul>
    </div>
}

@if (applicationStateService.userData && !applicationStateService.userData.loggedIn) {
    <a
            [attr.href]="'userGetLogin' | route"
            [size]="'40px'"
            [url]="'sidebar/sidebar-icon-profile.png' | asset"
            backgroundImage
            class="sidebar-nav-button"><span [style.bottom.px]="5">Login</span>
    </a>
}
